export function StreamFormatter() {

  const chunks = []
  const root = document.createElement('div')

  function addChunk(chunk) {
    chunks.push(chunk)
    processStart()
  }

  let processing = false

  function processStart() {
    if (processing) {
      return
    }
    process()
  }

  function process() {
    processing = true

    const chunk = chunks.shift()
    if (!chunk) {
      processing = false
      return
    }

    for (let i = 0; i < chunk.length; i++) {
      const letter = chunk[i]
      processLetter(letter)
    }

    process()
  }

  let buffer = '', item = null, subitem = null, newLine = true

  function createItem(tag) {
    const el = document.createElement(tag)
    root.appendChild(el)
    item = el
    subitem = null
  }

  function createSubitem(tag, txt = '') {
    if (item === null) {
      return
    }
    const el = tag === 'textnode' ? document.createTextNode(txt) : document.createElement(tag)
    item.appendChild(el)
    subitem = el
  }

  function processLetter(letter) {

    if (item === null) {
      if (letter === '#') {
        if (buffer === '' || buffer === '#' || buffer === '##') {
          buffer += letter
          return
        }
      }

      if (letter === '*') {
        if (buffer === '') {
          buffer += letter
          return
        }
      }

      if (letter === ' ') {
        if (buffer === '#' || buffer === '##' || buffer === '###') {
          createItem(`h${buffer.length}`)
          buffer = ''
          return
        }
        if (buffer === '*') {
          createItem('li')
          buffer = ''
          return
        }
      }

      if (letter === '`') {
        if (buffer === '' || buffer === '`') {
          buffer += letter
        } else if (buffer === '``') {
          createItem('pre')
          buffer = ''
        }
        return
      }

      createItem('p')
      if (buffer !== '') {
        createSubitem('textnode', buffer + letter)
        buffer = ''
        return
      }
    }

    if (item.tagName === 'PRE') {
      if (letter === '`') {
        if (buffer === '``') {
          item = null
          buffer = ''
        } else {
          buffer += letter
        }
      } else {
        item.textContent += letter
      }
      return
    }

    if (letter === "\n") {
      item = null
      newLine = true
      buffer = ''
      return
    }

    if (!newLine) {

      if (letter === '*') {
        if (buffer === '' || buffer === '*') {
          buffer += letter
          return
        }
      }

      if (buffer === '*') {
        if (subitem?.tagName !== 'I') {
          createSubitem('i')
        } else {
          subitem = null
        }
        buffer = ''
      }
  
      if (buffer === '**') {
        if (subitem?.tagName !== 'B') {
          createSubitem('b')
        } else {
          subitem = null
        }
        buffer = ''
      }

    }

    if (subitem === null) {
      createSubitem('textnode')
    }

    subitem.textContent += letter
    newLine = false
  }

  return {
    root,
    addChunk
  }
}